(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlRelatedRisksController', Controller);

    Controller.$inject = ['$scope', 'grcControlService', 'risks'];

    function Controller($scope, grcControlService, risks) {

        $scope.risks = risks;
        
        // Add a new related risk
        $scope.addRisk = function (risk) {

            grcControlService.addRiskToControl($scope.control.ControlID, risk.RiskID)
            .then(function (risks) {
                $scope.control.Risks = risks;
                $scope.risks = risks;
            });
        };

        // Unlink a risk
        $scope.unlinkRisk = function (risk) {

            grcControlService.removeRiskFromControl($scope.control.ControlID, risk.RiskID)
            .then(function () {
                $scope.control.Risks = _.reject($scope.control.Risks, { RiskID: risk.RiskID });
                $scope.risks = _.reject($scope.risks, { RiskID: risk.RiskID });
            });
        }
    }
})();